export default __webpack_public_path__ + "static/media/avatar-one.eed44262.png";